<template>
  <div>
    <v-menu open-on-hover bottom offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="mr-2"
          color="channelbtn"
          dark
          depressed
          v-bind="attrs"
          v-on="on"
        >
          Add
        </v-btn>
        <v-btn
          :disabled="removeBtnDisabled"
          color="error"
          depressed
          @click="deleteConfirmDialog = true"
          >Remove</v-btn
        >
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in addItems"
          :key="index"
          link
          @change="showAddUserDialog(item.action)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <div class="mt-4">
      <v-card>
        <v-card-title>
          Users
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          v-model="selectedUsers"
          :headers="headers"
          :items="users"
          item-key="email"
          :search="search"
          class="border"
          show-select
        >
        </v-data-table>
      </v-card>
    </div>
    <!-- 단일 유저 등록 모달창 -->
    <v-dialog v-model="addUserDialog" persistent max-width="500px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text"
            >Individual User</v-card-title
          >
          <div class="ml-auto">
            <v-btn icon @click="closeAddUserDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="pb-0">
          <v-container>
            <v-form ref="form" v-on:submit.prevent class="mt-5">
              <v-row v-for="(textField, i) in textFields" :key="i">
                <v-col md="11" sm="11" cols="11">
                  <v-text-field
                    v-model="textField.value"
                    :rules="emailRules"
                    :label="textField.label"
                    prepend-icon="mdi-email"
                    required
                    color="channel"
                  ></v-text-field>
                </v-col>
                <v-col md="1" sm="1" cols="1">
                  <v-btn icon @click="add"><v-icon>mdi-plus</v-icon></v-btn>
                  <v-btn @click="remove(i)" icon
                    ><v-icon>mdi-minus</v-icon></v-btn
                  ></v-col
                >
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="channelbtn"
            class="mr-2 white--text"
            @click="individualSave()"
          >
            Save
          </v-btn>
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="closeAddUserDialog()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 여러유저 등록 모달창 -->
    <v-dialog v-model="addUsersDialog" persistent max-width="600px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text"
            >Multiple Users</v-card-title
          >
          <div class="ml-auto">
            <v-btn icon @click="closeAddUsersDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7">
          <div class="mb-5">
            <v-btn class="info" small :href="sampleUrl"
              >CSV Sample Download</v-btn
            >
          </div>
          <v-form ref="form2">
            <v-file-input
              v-model="file"
              :rules="fileRules"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              placeholder="Select your file"
              prepend-icon="mdi mdi-paperclip"
              color="channel"
              @change="loadCSV()"
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="channelbtn"
            :disabled="multiSaveBtnDisabled"
            class="mr-2 white--text"
            @click="multipleSave()"
          >
            Save
          </v-btn>
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="closeAddUsersDialog()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 삭제확인모달창 -->
    <v-dialog v-model="deleteConfirmDialog" width="500">
      <v-card>
        <div color="error" class="d-flex pa-2 align-center error">
          <v-card-title class="headline white--text">Delete</v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="deleteConfirmDialog = false">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7">
          <v-icon small>mdi-alert-circle-outline</v-icon> Are you sure you want
          to delete the User?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            class="mr-2 text-capitalize"
            @click="deleteUserRoles()"
          >
            Delete
          </v-btn>
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="deleteConfirmDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { listUserRolesByRole } from "@/graphql/Query";
import { createUserRoles, deleteUserRoles } from "@/graphql/Mutation";
export default {
  name: "UserList",
  data: () => ({
    sampleUrl: "https://onseminar.com/pub/common/csv/sample.csv",
    parseCsv: null,
    parseHeader: [],
    users: [],
    selectedUsers: [],
    addUserDialog: false,
    addUsersDialog: false,
    deleteConfirmDialog: false,
    removeBtnDisabled: true,
    multiSaveBtnDisabled: true,
    id: "",
    textFields: [],
    errors: [],
    search: "",
    selectedId: "",
    name: "",
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || "E-mail must be valid";
      }
    ],
    file: null,
    fileRules: [
      file =>
        !file || file.size < 1e6 || "Avatar size should be less than 2 MB!"
    ],
    headers: [{ align: "start", text: "Email", value: "email" }],
    addItems: [
      { title: "Individual User", action: "individual" },
      { title: "Multiple Users", action: "multiple" }
    ]
  }),

  computed: {},
  watch: {
    selectedUsers: function(newVal) {
      /**
       * remove 버튼의 disabled를 user를 선택함에 따라 변경
       */
      console.log(newVal.length);
      if (newVal.length >= 1) {
        this.removeBtnDisabled = false;
      } else {
        this.removeBtnDisabled = true;
      }
    },
    parseCsv: function(newVal) {
      /**
       * 멀티유저 등록시 CSV를 JSON으로 파싱한 경우에 따라 등록 버튼 보여주기
       */
      this.multiSaveBtnDisabled = newVal ? false : true;
    },
    addUserDialog: function(newVal) {
      if (!newVal) this.initAddUserDialog();
    },
    addUsersDialog: function(newVal) {
      if (!newVal) this.initAddUsersDialog();
    }
  },
  mounted: async function() {
    this.initAddUserDialog();
    await this.getListUsers();
  },
  methods: {
    arrayUnique(array) {
      var a = array.concat();
      for (var i = 0; i < a.length; ++i) {
        for (var j = i + 1; j < a.length; ++j) {
          if (a[i] === a[j]) a.splice(j--, 1);
        }
      }
      return a;
    },
    initAddUserDialog() {
      /**
       * 개별 입력창 초기화
       */
      this.textFields = [];
      this.textFields.push({
        label: "E-mail",
        value: ""
      });
    },
    initAddUsersDialog() {
      /**
       * 멀티 입력창 초기화
       */
      this.parseCsv = null;
      this.file = null;
    },
    closeAddUserDialog() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.addUserDialog = false;
    },
    closeAddUsersDialog() {
      this.$refs.form2.reset();
      this.$refs.form2.resetValidation();
      this.addUsersDialog = false;
    },
    add() {
      /**
       * 개별입력시 이메일 입력필드 추가
       */
      if (this.textFields.length < 3) {
        this.textFields.push({
          label: "E-mail",
          value: ""
        });
      }
    },
    remove(index) {
      /**
       * 개별입력시 이메일 입력필드 삭제
       */
      if (this.textFields.length > 1) {
        this.textFields.splice(index, 1);
      }
    },

    async getListUsers() {
      /**
       * userRole을 role을 기준으로 가져오기
       * 채널##gu 로 채널유저 가져와 이메일 정렬 후 users에 입력
       */
      const limit = undefined;
      const nextToken = undefined;

      const { data } = await this.$apollo.query({
        query: listUserRolesByRole,
        variables: {
          user_role: `${this.$store.state.channelId}##gu`,
          limit: limit,
          nextToken: nextToken
        },
        fetchPolicy: "no-cache"
      });

      console.log(data);
      const items = data.listUserRolesByRole.items;
      this.users = items;
      this.users.sort((a, b) => (a.email > b.email ? 1 : -1));
    },

    async individualSave() {
      /**
       * 개별입력시 등록
       */
      if (!this.$refs.form.validate()) return;
      console.log({ textField: this.textFields });

      const saveUserRoles = this.textFields.map(item => {
        const email = item.value;
        const channel_id = this.$store.state.channelId;
        const role = "gu";
        return { email, channel_id, role };
        // console.log(email, channelId);
      });
      console.log({ saveUserRoles });
      try {
        const { data } = await this.$apollo.mutate({
          mutation: createUserRoles,
          variables: {
            input: saveUserRoles
          }
        });
        if (data && data.createUserRoles) {
          this.$store.dispatch("logger", {
            menu: "Users",
            level: "success",
            message: `Success to Register Channel ${saveUserRoles.length} Users  `,
            duration: 5000
          });

          await this.getListUsers();
        }
      } catch (error) {
        console.log({ error });
        if (error) {
          this.$store.dispatch("logger", {
            menu: "Users",
            level: "error",
            message: `Fail to Register Channel ${saveUserRoles.length} Users `,
            duration: 5000
          });
        }
      }
      this.closeAddUserDialog();
    },
    async multipleSave() {
      /**
       * 다중유저 등록시 5000명까지 appsync를 이용해 데이터 전송
       */

      // 데이터 검증단계

      // 서버에 등록 Mutation
      const users = this.parseCsv;
      let usersForSave = [];

      users.forEach(item => {
        console.log(item.email, this.validateEmail(item.email));
        if (this.validateEmail(item.email)) {
          const obj = {
            email: item.email,
            role: "gu",
            channel_id: this.$store.state.channelId
          };
          usersForSave.push(obj);
        }
      });

      const estimatedTime = Math.ceil((usersForSave.length * 0.4) / 60);
      console.log("usersForSave", usersForSave.length, usersForSave);
      try {
        const { data } = await this.$apollo.mutate({
          mutation: createUserRoles,
          variables: {
            input: usersForSave
          }
        });
        if (data && data.createUserRoles) {
          console.log({ data });
          await this.getListUsers();

          this.$store.dispatch("logger", {
            menu: "Users",
            level: "success",
            message: `Transmission success to register ${usersForSave.length} Channel Users.<br>
            Estimated time is about ${estimatedTime} minutes.`
          });
        }
      } catch (error) {
        if (error) {
          this.$store.dispatch("logger", {
            menu: "Users",
            level: "error",
            message: `Transmission error to register ${usersForSave.length} Channel Users.<br>
            Estimated time is about ${estimatedTime} minutes.
            `
          });
          console.log(error);
        }
      } finally {
        this.addUsersDialog = false;
      }
    },
    /**
     * deleteUserRoles
     *
     * 입력: [UserRole]   UserRole 객체{ email, role, channel_id, group_id, live_id }의 배열
     * 출력: 없음
     * 1. 선택한 유저들 (selectedUsers)을 가져온다
     * 2. userRole 테이블에서 조건이 일치하는 해당유저 레코드를 삭제한다.
     * 3. 해당유저의 레코드가 없다면 코그니토에서 삭제한다.
     *
     */

    async deleteUserRoles() {
      const usersForDelete = this.selectedUsers.map(item => {
        const obj = {
          email: item.email,
          role: "gu",
          channel_id: this.$store.state.channelId
        };
        return obj;
      });
      const estimatedTime = Math.ceil((usersForDelete.length * 0.2) / 60);

      try {
        const { data } = await this.$apollo.mutate({
          mutation: deleteUserRoles,
          variables: {
            input: usersForDelete
          }
        });

        if (data && data.deleteUserRoles) {
          this.$store.dispatch("logger", {
            menu: "Users",
            level: "success",
            message: `Transmission success for UnRegistering ${usersForDelete.length} Channel Users.<br>
            Estimated time is about ${estimatedTime} minutes.
            `
          });
        }
      } catch (error) {
        this.$store.dispatch("logger", {
          menu: "Users",
          level: "error",
          message: `Transmission fail for UnRegistering  ${usersForDelete.length} Channel Users.<br>
            Estimated time is about ${estimatedTime} minutes.
            `
        });
      }
      this.deleteConfirmDialog = false;
      this.users = this.users.filter(x => !this.selectedUsers.includes(x));
      this.selectedUsers = [];
    },
    showAddUserDialog(action) {
      /**
       * 개별입력, 다중입력 모달 선택하는 버튼 보여주기
       */
      if (action == "individual") this.addUserDialog = true;
      if (action == "multiple") this.addUsersDialog = true;
    },
    loadCSV() {
      /**
       * 대량 사용자등록을 위해 csv를 읽어오는 함수
       */
      if (this.file == null) return;
      const that = this;
      if (window.FileReader) {
        var reader = new FileReader();
        reader.readAsText(this.file);
        reader.onload = function(event) {
          var csv = event.target.result;
          console.log(csv);
          that.csvJSON(csv);
          console.log(that.parseCsv);
        };
        // Handle errors load
        reader.onerror = function(evt) {
          if (evt.target.error.name == "NotReadableError") {
            this.$notify({
              title: "Channel User",
              type: "error",
              text: `This File is not Readable`,
              duration: 5000,
              closeOnClick: true
            });
          }
        };
      } else {
        this.$notify({
          title: "Channel User",
          type: "error",
          text: `FileReader are not supported in this browser.`,
          duration: 5000,
          closeOnClick: true
        });
      }
    },
    csvJSON(csv) {
      const lines = csv.split("\n");
      const result = [];
      const headers = lines[0].split(",");
      const h = headers[0].trim();
      if (h != "email") {
        this.$notify({
          title: "Channel User",
          type: "error",
          text: `Header's name should be "email"`,
          duration: 5000,
          closeOnClick: true
        });
        return;
      }
      if (lines.length > 5002) {
        this.$notify({
          title: "Channel User",
          type: "error",
          text: "Allowed to register 1000 users at once",
          duration: 5000,
          closeOnClick: true
        });
        return;
      }
      lines.map(function(line, indexLine) {
        if (indexLine < 1) return; // Jump header line

        var obj = {};
        var currentline = line.split(",");

        headers.map(function(header, indexHeader) {
          obj[header.trim()] = currentline[indexHeader].trim();
        });

        result.push(obj);
      });
      //result.pop(); // remove the last item because undefined values
      this.parseCsv = result;
      //return result; // JavaScript object
    },
    validateEmail(email) {
      const regPttn = /\b[\w.-]+@[\w.-]+\.\w{2,4}\b/;
      console.log("email Match", typeof email, regPttn.test(email));
      if (typeof email === "string" && email.match(regPttn)) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
<style></style>
